import { memo } from 'react';
import { EApplicantOfferPGKeys } from 'api-paths-cas';
import { TableCellProps } from '../../../types';
import { Flex } from '@chakra-ui/react';
import { defaultHeaderRenderer } from '../../headers';
import { IColumn } from '../../types';
import { UNKNOWN_VALUE } from '../helpers';

const Formatter = memo(function formatter(cellProps: TableCellProps) {
  const reqsToAssess = cellProps.row.requirementsInAssessment ?? 0;
  const reqsWithCondition = cellProps.row.requirementsWithCondition ?? 0;

  if (!reqsToAssess && !reqsWithCondition) {
    return (
      <Flex height="100%" width="100%" flexDirection={'column'}>
        {UNKNOWN_VALUE}
      </Flex>
    );
  }

  const totalRequirements = reqsToAssess + reqsWithCondition;
  const requirementsToAssess = `${reqsToAssess}/${totalRequirements}`;
  return (
    <Flex height="100%" width="100%" flexDirection={'column'}>
      {requirementsToAssess}
    </Flex>
  );
});

export const RequirementsToAssessColumn = (): IColumn => ({
  item: {
    key: EApplicantOfferPGKeys.REQUIREMENTS_IN_ASSESSMENT,
    name: 'To Assess',
    headerRenderer: defaultHeaderRenderer,
    width: 'minmax(128px, 1fr)',
    sortable: true,
    formatter: Formatter,
  },
  visible: () => true,
});
